import React from "react";
import { Spinner } from "../../components";
import BookStore from "../../../../stores/book-store";
import { MenuMixin } from "../../../ui_elements/menu";
var modalPosition;

class DefineContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      definition: null,
      title: null
    };

    this._filterApiResults = this._filterApiResults.bind(this);
    this.positionModal = this.positionModal.bind(this);
    this._cleanseWord = this._cleanseWord.bind(this);
    this._callPearson = this._callPearson.bind(this);
  }

  componentDidMount() {
    this._callPearson();
    this.positionModal();
    MenuMixin._removeMenu();
  }

  _filterApiResults(responseJson, currentWord) {
    let definition = i18n.t("dictionary-lookup.no-def-found");
    let modalTitle = i18n.t("base.sorry");

    responseJson.results = responseJson.data.results;
    if (
      (responseJson !== null || responseJson.results.length !== 0) &&
      responseJson !== "No Definition"
    ) {
      let totalResults = responseJson.results.length;
      for (var i = 0; i < totalResults; i++) {
        if (
          responseJson.results[i].senses &&
          responseJson.results[i].senses[0].definition
        ) {
          if (
            responseJson.results[i].headword.toLowerCase() ===
            currentWord.toLowerCase()
          ) {
            definition = responseJson.results[i].senses[0].definition;
            modalTitle = responseJson.results[i].headword;
            this.props.changeModalTitle(modalTitle);
            break;
          }
          if (i === totalResults - 1) {
            if (totalResults && responseJson.results[0].senses[0].definition) {
              definition = responseJson.results[0].senses[0].definition[0];
            } else {
              if (
                totalResults &&
                responseJson.results[0].senses[0].definition
              ) {
                definition = responseJson.results[7].senses[0].definition[0];
              } else if (
                totalResults &&
                responseJson.results[0].senses[0].signpost
              ) {
                definition = responseJson.results[0].senses[0].signpost;
              }
            }
            modalTitle = responseJson.results[0].headword;
            this.props.changeModalTitle(modalTitle);
          }
        }
      }
    }
    this.setState({
      definition: definition,
      isLoading: false
    });
  }

  positionModal() {
    let selectionData = this.props.selectionData.selectionPosition;
    let heightOfModal = $("#modal-container").height();
    let browserHeight = $(window).height();
    if (selectionData) {
      if (selectionData.top > 700) {
        selectionData.top = selectionData.top - (heightOfModal + 15);
      } else if (selectionData.top > browserHeight / 2) {
        selectionData.top = selectionData.top + 45;
      } else if (selectionData.top > browserHeight / 3) {
        selectionData.top = selectionData.bottom + 15;
      } else {
        selectionData.top = selectionData.top + 45;
      }

      if (selectionData.left > browserHeight / 2) {
        selectionData.left = selectionData.left - 250;
      } else if ($(window).width() < 720 && selectionData.left > 250) {
        selectionData.left = selectionData.left - 295;
      }
    }
    return selectionData;
  }

  _cleanseWord(word) {
    let wordArray = word.split(" ");
    let largestWord = "";
    if (wordArray.length > 1) {
      let lengthOfLongestWord = 0;
      for (var i = 0; i < wordArray.length; i++) {
        if (wordArray[i].length > lengthOfLongestWord) {
          lengthOfLongestWord = wordArray[i].length;
          largestWord = wordArray[i];
        }
      }
    } else {
      largestWord = wordArray[0];
    }
    largestWord = largestWord.replace(/\W/g, "");
    return largestWord;
  }

  _callPearson() {
    let currentWord = this._cleanseWord(this.props.currentSelectedText);
    const book = BookStore.get(this.props.isbn);
    let dataStuff;
    let success = response => {
      dataStuff = response;
      this._filterApiResults(dataStuff, currentWord);
    };
    book.viewer.Book.dictionaryLookup(currentWord, success);
    Fraction.Reporter.gaEvent("define", currentWord, this.props.isbn);
  }

  render() {
    let content = this.state.isLoading ? <Spinner /> : this.state.definition;
    return (
      <div>
        <link
          href="/styles/dictionary-lookup/css.css"
          rel="stylesheet"
          type="text/css"
        />
        {content}
      </div>
    );
  }
}

const defineWord = selectionData => {
  let title = selectionData.currentSelectedText;
  Fraction.Helpers.showModal({
    title: title,
    content: (
      <DefineContainer
        currentSelectedText={title}
        selectionData={selectionData}
        isbn={selectionData.isbn}
      />
    ),
    closeCallback: () => {},
    fullscreen: false,
    definingClass: "dictionary-modal",
    position: selectionData.selectionPosition,
    intersitial: false,
    buttons: [],
    width: null,
    height: null
  });
};

module.exports = {
  metadata: () => {
    return {
      id: "dictionary-lookup",
      name: i18n.t("dictionary-lookup.lookup-in-dictionary"),
      description: i18n.t("dictionary-lookup.description"),
      enabled: (isbn, selectionData) => {
        var currentLanguage = i18n.getCurrentLocale();
        return (
          (currentLanguage === "en_GB" || currentLanguage === "en") &&
          (!Fraction.Brand.Labs.enabled ||
            Fraction.Helpers.isLabEnabled("dictionary-lookup")) &&
          (selectionData.currentSelectedText &&
            selectionData.currentSelectedText.split(/\s+/).length <= 3)
        );
      },
      action: (isbn, selectionData) => {
        defineWord(selectionData);
      },
      toggle: () => {},
      lab: "student",
      resetHighlightData: true,
      expanded: true,
      type: "context"
    };
  }
};
